import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import QrCodeWithLogo from "qrcode-with-logos";


@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {
  

  constructor(private productService:ServiceService,private route: ActivatedRoute, private router: Router) { }
  
  
  output:any=[]; //---store get() result--------
  productId='';
  myAngularQrcode:any=""
  //getUrl='http://192.241.151.66:5000/viewProducts';
  
  name="";
  rak_std_price="";
  test="";
  aweer_std_price="";
  dip_std_price="";
  abudhabi_std_price="";
  qusais_std_price="";
  shj_std_price="";
  al_quiz_std_price="";
  al_ain_std_price="";
  accounting_price="";
  sajaa_std_price="";
  price_level_1="";
  btnShown=false
  StockArray=[]
   base64Img:any;
   NewFileName:any

//====================================================================
Image(){
let qrcode = new QrCodeWithLogo({
  // canvas : document.getElementById("canvas666")as HTMLElement,
   content: this. myAngularQrcode,
   width: 380,
   //   download: true,
 //  image: document.getElementById("image"),
   logo: {
     src: "assets/img/QRlogo.jpeg"
   }
 });
  
 qrcode.toCanvas().then(() => {
   qrcode.toImage().then(() => {
     
       qrcode.downloadImage(this.NewFileName);
     
   });
 });
}
 //=====================================================================
   
  goToLink(link:any){
    window.open(link);
  }
  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
  //------routing to edit page--------------------  
EditProducts(){
  this.router.navigateByUrl(('admin/edit-product'));  
  console.log("call edit product")
}
//--------function which give name of selected item---------
getValue(){
  this.productService.setProductId( this.productId)
  document.body.scrollTop = document.documentElement.scrollTop = 0;

}
/*
//----function for qr code downloading------------
saveAsImage(parent:any) {

  this.NewFileName=this.output[0].product_name.replace(/ /g, "_");
  this.NewFileName = this.NewFileName.substring(0,this.NewFileName.length - 1);

  let newVariable: any;
  newVariable = window.navigator;
 
  console.log("element=",parent.qrcElement.nativeElement)

   // fetches base 64 date from image
  const parentElement = parent.qrcElement.nativeElement.querySelector("img").src;
  console.log("data=", parentElement)
  // converts base 64 encoded image to blobData
  
  let blobData = this.convertBase64ToBlob(parentElement);
 

  console.log("window=",newVariable)
  // saves as image
  if (newVariable && newVariable.msSaveOrOpenBlob) { //IE
    newVariable.msSaveOrOpenBlob(blobData, 'Qrcode');
    console.log("in iff")

  } 
  else { // chrome
    console.log("in else")
    
    
    const blob = new Blob([blobData], { type: 'image/png' });
    const url = window.URL.createObjectURL(blob);
    // window.open(url);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.NewFileName;
    link.click();
  }
  
}


private convertBase64ToBlob(Base64Image: any) {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: imageType });
  
}
*/
//--------------------------------------------------------------------------
Hello(){
  
}

//---------------------------------------------------------------------------
  ngOnInit(): void {

    //---call function in service for product Id------
    this.productId=this.productService.getProductId()
     console.log("product id=",this.productId)

    //-------api get()calling-------------
    this.productService.ViewProducts('/'+this.productId).subscribe((res)=>{
      this.output=res.data
      console.log("productDetail =",this.output)
      this.name=this.output[0].product_name
      this.StockArray=this.output[0].stock_statement
      console.log("array=",this.StockArray)

      if(this.output[0].technical_document!=""){
        this.btnShown=true;
        this.myAngularQrcode=this.output[0].technical_document;

        this.NewFileName=this.output[0].product_name.replace(/ /g, "_");
        this.NewFileName = this.NewFileName.substring(0,this.NewFileName.length - 1);
      }

      //---------new price------------------------------------
      if(this.output[0].tempPrices.length!=0){
      
        for(var i=0;i<this.output[0].tempPrices.length;i++){
  
         //console.log(this.output[0].tempPrices[i].price_type_name)
         if(this.output[0].tempPrices[i].price_type_name=='RAK STD PRICE'){
  
          this.rak_std_price=this.output[0].tempPrices[i].price;
  
         }
         else if(this.output[0].tempPrices[i].price_type_name=='AWEER STD PRICE')
         {
  
           this.aweer_std_price=this.output[0].tempPrices[i].price;
          
         }
         else if(this.output[0].tempPrices[i].price_type_name=='DIP STD PRICE')
         {
   
           this.dip_std_price=this.output[0].tempPrices[i].price;
          
         }
         else if(this.output[0].tempPrices[i].price_type_name=='ABU DHABI STD PRICE')
         {
  
           this.abudhabi_std_price=this.output[0].tempPrices[i].price;
          
         }
         else if(this.output[0].tempPrices[i].price_type_name=='QUSAIS STD PRICE')
         {
  
           this.qusais_std_price=this.output[0].tempPrices[i].price;
          
         }
         else if(this.output[0].tempPrices[i].price_type_name=='SHJ STD PRICE')
         {
  
           this.shj_std_price=this.output[0].tempPrices[i].price;
          
         }
         else if(this.output[0].tempPrices[i].price_type_name=='AL QUOZ STD PRICE')
         {
  
           this.al_quiz_std_price=this.output[0].tempPrices[i].price;
          
         }
         else if(this.output[0].tempPrices[i].price_type_name=='AL AIN STD PRICE')
         {
  
           this.al_ain_std_price=this.output[0].tempPrices[i].price;
          
         }
         else if(this.output[0].tempPrices[i].price_type_name=='ACCOUNTING PRICE')
         {
  
           this.accounting_price=this.output[0].tempPrices[i].price;
          
         }
         else if(this.output[0].tempPrices[i].price_type_name=='SAJAA STD PRICE')
         {
  
           this.sajaa_std_price=this.output[0].tempPrices[i].price;
          
         }
         else if(this.output[0].tempPrices[i].price_type_name=='PRICE LEVEL 1')
         {
  
           this.price_level_1=this.output[0].tempPrices[i].price;
          
         }
         else if(this.output[0].tempPrices[i].price_type_name=='TEST')
         {
  
           this.test=this.output[0].tempPrices[i].price;
          
         }
  
          
        } //end for
        
      }
     //-------------------------------------------------------
    })

  }

}
